import { Component, OnInit } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  public appName = "";
  public toyotaPrivacyLink = [];
  public lexusPrivacyLink = [];
  constructor() {}

  ngOnInit() {
    this.appName = environment.applicationName;
    this.toyotaPrivacyLink = [
      {
        privacyLinkName: "YOUR PRIVACY CHOICES",
        privacyLinkUrl: "https://privacy.toyota.com/#/landing",
      },
      {
        privacyLinkName: "Legal Terms",
        privacyLinkUrl: "https://www.toyota.com/support/legal-terms",
      },
      {
        privacyLinkName: "Privacy Notice",
        privacyLinkUrl: "https://www.toyota.com/support/privacy-notice/",
      },
      {
        privacyLinkName: "Connected Services Privacy Notice",
        privacyLinkUrl: "https://www.toyota.com/privacyvts/",
      },
      {
        privacyLinkName: "How to Disconnect Remote Vehicle Access",
        privacyLinkUrl: "https://disconnectaccess.toyota.com/#/drva-landing",
      },
      {
        privacyLinkName: "Cookie Consent Options",
        privacyLinkUrl: "",
      },
    ];
    this.lexusPrivacyLink = [
      {
        privacyLinkName: "YOUR PRIVACY CHOICES",
        privacyLinkUrl: "https://privacy.toyota.com/#/landing",
      },
      {
        privacyLinkName: "LEGAL",
        privacyLinkUrl: "https://www.lexus.com/privacy/legal-terms",
      },
      {
        privacyLinkName: "PRIVACY NOTICE",
        privacyLinkUrl: "https://www.lexus.com/privacy",
      },
      {
        privacyLinkName: "CONNECTED SERVICES PRIVACY NOTICE",
        privacyLinkUrl: "https://www.lexus.com/privacyvts",
      },
      {
        privacyLinkName: "HOW TO DISCONNECT REMOTE VEHICLE ACCESS",
        privacyLinkUrl: "https://disconnectaccess.lexus.com/#/drva-landing",
      },
      {
        privacyLinkName: "COOKIE CONSENT OPTIONS",
        privacyLinkUrl: "",
      },
    ];
  }
  /**
   * Opens the cookie consent modal via the gateway global interface.
   * Uses `globalThis` for cross-environment compatibility (browser, SSR, Web Workers).
   */
  openCookieConsentModal() {
    if (globalThis['gateway'] && typeof globalThis['gateway'].openModal === 'function') {
      globalThis['gateway'].openModal();
    }
  }
}